/** USPS Ship (direct) mail classes and the rate.service strings they stamp. */
export enum UspsReturnsMailClass {
  GroundAdvantageReturn = "USPS_GROUND_ADVANTAGE_RETURN_SERVICE",
  PriorityMailReturn = "PRIORITY_MAIL_RETURN_SERVICE",
  PriorityMailExpressReturn = "PRIORITY_MAIL_EXPRESS_RETURN_SERVICE",
}

export const USPS_RETURNS_MAIL_CLASSES: readonly UspsReturnsMailClass[] = [
  UspsReturnsMailClass.GroundAdvantageReturn,
  UspsReturnsMailClass.PriorityMailReturn,
  UspsReturnsMailClass.PriorityMailExpressReturn,
];

export const USPS_RETURNS_MAIL_CLASS_LABELS: Record<
  UspsReturnsMailClass,
  string
> = {
  [UspsReturnsMailClass.GroundAdvantageReturn]: "USPS Ground Advantage Return",
  [UspsReturnsMailClass.PriorityMailReturn]: "USPS Priority Mail Return",
  [UspsReturnsMailClass.PriorityMailExpressReturn]:
    "USPS Priority Mail Express Return",
};

export enum UspsOutboundMailClass {
  GroundAdvantage = "USPS_GROUND_ADVANTAGE",
  PriorityMail = "PRIORITY_MAIL",
  PriorityMailExpress = "PRIORITY_MAIL_EXPRESS",
}

export const USPS_OUTBOUND_MAIL_CLASSES: readonly UspsOutboundMailClass[] = [
  UspsOutboundMailClass.GroundAdvantage,
  UspsOutboundMailClass.PriorityMail,
  UspsOutboundMailClass.PriorityMailExpress,
];

export const USPS_OUTBOUND_MAIL_CLASS_LABELS: Record<
  UspsOutboundMailClass,
  string
> = {
  [UspsOutboundMailClass.GroundAdvantage]: "USPS Ground Advantage",
  [UspsOutboundMailClass.PriorityMail]: "USPS Priority Mail",
  [UspsOutboundMailClass.PriorityMailExpress]: "USPS Priority Mail Express",
};

export enum UspsInternationalMailClass {
  FirstClassPackageInternational = "FIRST-CLASS_PACKAGE_INTERNATIONAL_SERVICE",
  PriorityMailInternational = "PRIORITY_MAIL_INTERNATIONAL",
  PriorityMailExpressInternational = "PRIORITY_MAIL_EXPRESS_INTERNATIONAL",
}

export const USPS_INTERNATIONAL_MAIL_CLASSES: readonly UspsInternationalMailClass[] =
  [
    UspsInternationalMailClass.FirstClassPackageInternational,
    UspsInternationalMailClass.PriorityMailInternational,
    UspsInternationalMailClass.PriorityMailExpressInternational,
  ];

export const USPS_INTERNATIONAL_MAIL_CLASS_LABELS: Record<
  UspsInternationalMailClass,
  string
> = {
  [UspsInternationalMailClass.FirstClassPackageInternational]:
    "USPS First-Class Package International",
  [UspsInternationalMailClass.PriorityMailInternational]:
    "USPS Priority Mail International",
  [UspsInternationalMailClass.PriorityMailExpressInternational]:
    "USPS Priority Mail Express International",
};

export type UspsDirectMailClass =
  | UspsReturnsMailClass
  | UspsOutboundMailClass
  | UspsInternationalMailClass;

export type UspsDirectRateFlow = "return" | "outbound" | "international";

const RETURNS_MAIL_CLASS_VALUES = new Set<string>(
  Object.values(UspsReturnsMailClass),
);
const INTERNATIONAL_MAIL_CLASS_VALUES = new Set<string>(
  Object.values(UspsInternationalMailClass),
);

export function isUspsReturnsMailClass(
  mc: UspsDirectMailClass,
): mc is UspsReturnsMailClass {
  return RETURNS_MAIL_CLASS_VALUES.has(mc);
}

export function isUspsInternationalMailClass(
  mc: UspsDirectMailClass,
): mc is UspsInternationalMailClass {
  return INTERNATIONAL_MAIL_CLASS_VALUES.has(mc);
}

export function uspsDirectMailClassLabel(mc: UspsDirectMailClass): string {
  if (isUspsReturnsMailClass(mc)) {
    return USPS_RETURNS_MAIL_CLASS_LABELS[mc];
  }
  if (isUspsInternationalMailClass(mc)) {
    return USPS_INTERNATIONAL_MAIL_CLASS_LABELS[mc];
  }
  return USPS_OUTBOUND_MAIL_CLASS_LABELS[mc];
}

export function uspsDirectMailClassFlow(
  mc: UspsDirectMailClass,
): UspsDirectRateFlow {
  if (isUspsReturnsMailClass(mc)) {
    return "return";
  }
  if (isUspsInternationalMailClass(mc)) {
    return "international";
  }
  return "outbound";
}
